import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { SafeUrl } from '@angular/platform-browser';
import Swal from './swal-compat';
import { PhotoViewDialogComponent } from '../components/photo-view-dialog/photo-view-dialog.component';

@Injectable({
  providedIn: 'root',
})
export class ProfilePhotoService {
  constructor(
    private dialog: MatDialog,
    private translate: TranslateService,
  ) {}

  /**
   * Abre o diálogo de visualização da foto de perfil em alta resolução
   */
  openPhotoView(photoUrl: string | SafeUrl, userName?: string): void {
    this.dialog.open(PhotoViewDialogComponent, {
      data: { photoUrl, userName },
      maxWidth: '95vw',
      panelClass: 'photo-view-dialog-panel',
    });
  }

  /**
   * Pede confirmação amigável antes de remover a foto de perfil
   */
  async confirmRemovePhoto(): Promise<boolean> {
    const result = await Swal.fire({
      title: this.translate.instant('USERMENU.PHOTO_MENU.CONFIRM_REMOVE_TITLE'),
      text: this.translate.instant('USERMENU.PHOTO_MENU.CONFIRM_REMOVE_TEXT'),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#dc3545',
      cancelButtonColor: '#1B1464',
      confirmButtonText: this.translate.instant('USERMENU.PHOTO_MENU.CONFIRM_REMOVE_YES'),
      cancelButtonText: this.translate.instant('USERMENU.PHOTO_MENU.CONFIRM_REMOVE_NO'),
      reverseButtons: true,
    });
    return !!result.isConfirmed;
  }
}
